export const hueAlterColor = (startColor,hueAlteration=0) => {
    let hueAlterable = startColor.split('hsla(')[1]
        hueAlterable = parseInt(hueAlterable.split(',')[0])
        hueAlterable = hueAlterable + hueAlteration;
        hueAlterable = (hueAlterable > 360) ? hueAlterable - 360 : hueAlterable;
    let lam = startColor.split(',');
        lam.shift()
        lam = lam.join(',');
    let hueAltered = 'hsla('+parseInt(hueAlterable)+','+lam
    return hueAltered;
}

export const deepCopy = ob => JSON.parse(JSON.stringify(ob))
export const generateMeshCSS = (schema,hue) => {


    let ob = []

    for (let i in schema){
        
        const item = schema[i]
        const {p,c} = item;
        let ret = 'radial-gradient(at';
        const startColor = hueAlterColor(c,hue)
        for (let position in p){
            position = parseInt(position)
            ret += ' '+p[position]+'%'
        }
        ret += ', '+startColor+' 0px, transparent 50%)'
        ob.push(ret)
    }
    return ob.join(',')    
/* 
    if (mesher){
        for (let i in schema){
            i = parseInt(i)
            let ret = '';
            const s = schema[i]
    
            ret += '  \nradial-gradient(at';
            let pos = {}
            let startColor = s.c;
            
            //let hueAltered = (storing) ? startColor : this.getHueAlteredColor(startColor)
            let hueAltered = this.getHueAlteredColor(startColor);
            
            for (let j in s.p){
                j = parseInt(j)
                
                ret += ' '+s.p[j]+'%'
                if (j === 0) pos.x = (s.p[j]*mesher.clientWidth)/100;
                if (j === 1) pos.y =(s.p[j]*mesher.clientHeight)/100;
            }
            if (!storing) container.dots.push(<Draggable onDrag={(e)=>this.handleDrag(e,i)} key={i} axis='none' position={pos} bounds="parent"><div style={{backgroundColor:hueAltered}} className='sm'></div></Draggable>)
            
        
            
            ret += ', '+hueAltered+' '+s.s[0]+', transparent '+s.s[1]+')';
            ob.push(ret)
        }
    }
    if (storing){
        return ob.join(',');
    } else {
        this.setState({dots:container.dots,bg:ob.join(',')})
    } */
}

export const getDraggedPixels = (val,parent,maxVal) => {	
    if (!parent) return 0;
    let xPos = val - parent.offsetLeft;
        xPos = (xPos < 0) ? 0 : xPos;
        xPos = (xPos > parent.clientWidth) ? parent.clientWidth : xPos;
    const ret = parseInt((maxVal*xPos)/parent.clientWidth);
    return ret
}

export const placeDragger = (val,parent,max) => {
    if (parent){
        const full = parseInt(parent.clientWidth);
        const pos = (val*full)/max;
        return pos;
    } else {
        return 0
    }
}

export const hslaValueChange = (c,newValue,where) => {
    let w = c.split(',')
    let newSat = newValue;
    if (newSat < 0) newSat = 0;
    if (newSat > 100) newSat = 100;
    w[where] = newSat+'%'
    return w.join(',')
}

export const hslToHex = (h,s,l) =>{
	h /= 360;
	s /= 100;
	l /= 100;
	let r, g, b;
	if (s === 0) {
		r = g = b = l; // achromatic
	} else {
		const hue2rgb = (p, q, t) => {
			if (t < 0) t += 1;
			if (t > 1) t -= 1;
			if (t < 1 / 6) return p + (q - p) * 6 * t;
			if (t < 1 / 2) return q;
			if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
			return p;
		}
		const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
		const p = 2 * l - q;
		r = hue2rgb(p, q, h + 1 / 3);
		g = hue2rgb(p, q, h);
		b = hue2rgb(p, q, h - 1 / 3);
	}
	const toHex = x => {
		const hex = Math.round(x * 255).toString(16);
		return hex.length === 1 ? '0' + hex : hex;
	}
	return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
export const getRandom = (min,max) => {
    const random = Math.floor(Math.random() * (+max - +min)) + +min; 
    return random;
}

export const generateRandomPoint = () => {
    const r = getRandom;
    const hue = r(0,360);
    const sat = r(60,100);
    const lum = r(60,80)
    const spr = r(40,60);
    return {p:[r(0,100),r(0,100)],c:'hsla('+hue+','+sat+'%,'+lum+'%,1)',s:[0,spr+'%']}
}